import { formatCoordStr, getCountryNameFromCode } from '@src/utils/helpers';
import LinkButton from '@components/link/linkButton';
import genericSecondaryModal from '@pages/Forms/components/modals/genericSecondaryModal';
import { useModal } from '@stores';
import LabelValue from '@components/label-value/LabelValue';

const ProjectLocationSummary = ({
  areaLabel = 'Project Area (size)',
  summaryData,
  directionsLabel = 'Directions to Project Location',
}) => {
  const { openSecondaryModal } = useModal();

  return (
    <>
      <div>
        <section className='proj-section margin-top-2'>
          <h3> Project Location</h3>
          <div className='proj-flex-container'>
            <div className='proj-flex-item'>
              <div className='proj-flex-container'>
                <div className='proj-flex-item'>
                  <LabelValue label='Address' value={summaryData?.address} />
                  <LabelValue label='Address Line 2' value={summaryData?.addressTwo} />
                  <LabelValue label='City' value={summaryData?.city} />
                  <LabelValue label={summaryData?.country === 'US' ? 'State' : 'Region'} value={summaryData?.state} />
                  <LabelValue
                    label={summaryData?.country === 'US' ? 'Zip Code' : 'Postal Code'}
                    value={summaryData?.zipcode}
                  />
                </div>
                <div className='proj-flex-item'>
                  <LabelValue label='County' value={summaryData?.county} />
                  <LabelValue
                    label='Country'
                    value={getCountryNameFromCode(summaryData?.country) || summaryData?.country}
                  />
                  <LabelValue label='District' value={summaryData?.district} />
                  <LabelValue label='Latitude' value={formatCoordStr(summaryData?.latitude)} />
                  <LabelValue label='Longitude' value={formatCoordStr(summaryData?.longitude)} />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className='proj-section flex-item'>
          <h3>Project Details</h3>
          <div className='proj-flex-container'>
            <div className='proj-flex-item'>
              <LabelValue label='DA Number' value={summaryData?.daNumbers} />
              <LabelValue label='Previous File Number(s)' value={summaryData?.previousFileNumbers?.join(', ')} />
              <LabelValue label='Field Office Code' value={summaryData?.fieldOfficeCode} />
              <LabelValue label='PLSS Section' value={summaryData?.plssSection} />
              <LabelValue label='PLSS Township' value={summaryData?.plssTownship} />
              <LabelValue label='PLSS Township Direction' value={summaryData?.plssTownshipDir} />
              <LabelValue label='PLSS Range' value={summaryData?.plssRange} />
              <LabelValue label='PLSS Range Direction' value={summaryData?.plssRangeDir} />
            </div>
            <div className='proj-flex-item'>
              <LabelValue label={areaLabel} value={summaryData?.projectArea} />
              <LabelValue label='Unit of Measurement' value={summaryData?.unitOfMeasurement} />
              <LabelValue label='Parcel Number' value={summaryData?.parcelNumber} />
              <LabelValue
                label='Nearest Waterbody'
                value={
                  summaryData?.nearestWaterbody?.length > 60 ? (
                    <LinkButton
                      onClick={() =>
                        openSecondaryModal(genericSecondaryModal, {
                          msg: summaryData?.nearestWaterbody,
                          title: 'Nearest Waterbody',
                          hasCloseButton: false,
                        })
                      }
                      content='Click to view nearest waterbody'
                    />
                  ) : (
                    summaryData?.nearestWaterbody
                  )
                }
              />
              <LabelValue
                label={directionsLabel}
                value={
                  summaryData?.siteDirections?.length > 60 ? (
                    <LinkButton
                      onClick={() =>
                        openSecondaryModal(genericSecondaryModal, {
                          msg: summaryData?.siteDirections,
                          title: 'Project/Site Directions',
                          hasCloseButton: false,
                        })
                      }
                      content='Click to view project/site directions'
                    />
                  ) : (
                    summaryData?.siteDirections
                  )
                }
              />
              <LabelValue label='Created Date' value={summaryData?.createdDate} />
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default ProjectLocationSummary;
